import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "text-left" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-left" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = {
  class: "text-left",
  colspan: "3"
}
const _hoisted_8 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_oss_text_field_filled = _resolveComponent("oss-text-field-filled")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_oss_data_table = _resolveComponent("oss-data-table")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.resourceAllocations && _ctx.resourceAllocations.length)
    ? (_openBlock(), _createBlock(_component_v_card, {
        key: 0,
        class: "default_card large mx-0 my-2 pa-2",
        elevation: "0"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            class: "d-flex align-center justify-space-between"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "2",
                class: "pb-2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("h2", null, _toDisplayString(_ctx.resourceAllocationTitle), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "3",
                class: "pb-2 pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_select_filled, {
                    modelValue: _ctx.resourceAllocationPeriod,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.resourceAllocationPeriod) = $event)),
                    items: _ctx.resourceAllocationPeriods,
                    "hide-details": "auto",
                    label: "Période"
                  }, null, 8, ["modelValue", "items"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_col, {
                cols: "1",
                class: "pb-2 pl-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    size: "small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openEditionDialog(false))),
                    disabled: !!!_ctx.filteredProductTags && !!!_ctx.filteredProductTags.length
                  }, {
                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                      _createTextVNode(_toDisplayString("Ajouter"))
                    ])),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.resourceAllocations && _ctx.resourceAllocations.length)
            ? (_openBlock(), _createBlock(_component_v_row, {
                key: 0,
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "3",
                    class: "text-h6"
                  }, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode(" Ressource ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "text-h6"
                  }, {
                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                      _createTextVNode(" Surface ")
                    ])),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "2",
                    class: "text-h6"
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode(" Rendement ")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredResourceAllocations, (resourceAllocation, index) => {
            return (_openBlock(), _createBlock(_component_v_row, {
              "no-gutters": "",
              key: index,
              class: "pb-1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "3",
                  style: {"align-content":"center"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(resourceAllocation.name), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, {
                  cols: "2",
                  style: {"align-content":"center"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getSymbolText(resourceAllocation)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, {
                  cols: "2",
                  style: {"align-content":"center"}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getYieldText(resourceAllocation, resourceAllocation.productQuantityType)), 1)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_col, { cols: "1" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn_icon, {
                      icon: "$oss-edit",
                      density: "compact",
                      size: "small",
                      color: "secondary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openEditionDialog(true)))
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_oss_dialog, {
            modelValue: _ctx.editDialog,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.editDialog) = $event)),
            "valid-disabled": _ctx.disableValidate(),
            title: "Répartition",
            "valid-title": _ctx.editionAllocations.length ? 'Modifier' : 'Créer',
            onValid: _cache[8] || (_cache[8] = ($event: any) => (_ctx.valid())),
            onClose: _cache[9] || (_cache[9] = ($event: any) => (_ctx.close())),
            validLoading: _ctx.loading,
            width: "80vw"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_container, { class: "px-6 pb-6" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, {
                        cols: "1",
                        class: "pl-2",
                        style: {"align-content":"center"}
                      }, {
                        default: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createTextVNode(" Période : ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_v_col, {
                        cols: "3",
                        class: "pr-2"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_picker_filled, {
                            modelValue: _ctx.startDate,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.startDate) = $event)),
                            label: "Date de début",
                            textFieldReadOnly: false,
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, { cols: "3" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_oss_date_picker_filled, {
                            modelValue: _ctx.endDate,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.endDate) = $event)),
                            label: "Date de fin",
                            textFieldReadOnly: false,
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_row, { "no-gutters": "" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_oss_data_table, {
                        headers: _ctx.headers,
                        items: _ctx.editionAllocations,
                        class: "table",
                        "fixed-header": "",
                        "fixed-footer": true,
                        "max-height": "60vh",
                        "hide-default-footer": true
                      }, {
                        item: _withCtx(({ item, index }) => [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_1, _toDisplayString(item.name), 1),
                            _createElementVNode("td", _hoisted_2, [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_oss_text_field_filled, {
                                        modelValue: item.production,
                                        "onUpdate:modelValue": ($event: any) => ((item.production) = $event),
                                        class: "custom-text-field",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: item.resourceQuantityType,
                                        "onUpdate:modelValue": ($event: any) => ((item.resourceQuantityType) = $event),
                                        items: _ctx.quantityTypes,
                                        "item-value": "value",
                                        class: "pl-2 mt-0",
                                        "item-title": (item) => item.text
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.getSymbolText(item)), 1),
                            _createElementVNode("td", _hoisted_4, [
                              _createVNode(_component_v_row, {
                                "no-gutters": "",
                                class: "align-center"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_col, { cols: "5" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: item.productUnitQuantity,
                                        "onUpdate:modelValue": ($event: any) => ((item.productUnitQuantity) = $event),
                                        items: _ctx.getQuantityValues(item.productQuantityType),
                                        "item-value": "value",
                                        class: "mt-0",
                                        "item-title": (item) => item.symbol
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_v_col, { cols: "7" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_select_filled, {
                                        modelValue: item.productQuantityType,
                                        "onUpdate:modelValue": [($event: any) => ((item.productQuantityType) = $event), ($event: any) => (item.productUnitQuantity = 1)],
                                        items: _ctx.quantityTypes,
                                        "item-value": "value",
                                        class: "pl-2 mt-0",
                                        "item-title": (item) => item.text
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "item-title"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _createElementVNode("td", null, [
                              _createVNode(_component_oss_text_field_filled, {
                                modelValue: item.yield,
                                "onUpdate:modelValue": ($event: any) => ((item.yield) = $event),
                                rounded: "",
                                class: "custom-text-field",
                                "hide-details": ""
                              }, null, 8, ["modelValue", "onUpdate:modelValue"])
                            ]),
                            _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.getYieldText(item, item.productQuantityType)), 1),
                            _createElementVNode("td", _hoisted_6, [
                              _createVNode(_component_v_btn_trash, {
                                size: "x-small",
                                onClick: ($event: any) => (_ctx.deleteAllocation(item.id, index))
                              }, null, 8, ["onClick"])
                            ])
                          ])
                        ]),
                        "body.append": _withCtx(() => [
                          _createElementVNode("tr", null, [
                            _cache[15] || (_cache[15] = _createElementVNode("td", { colspan: "2" }, null, -1)),
                            _cache[16] || (_cache[16] = _createElementVNode("td", { class: "text-right" }, "Ajouter :", -1)),
                            _createElementVNode("td", _hoisted_7, [
                              _createVNode(_component_v_select_filled, {
                                outlined: "",
                                modelValue: _ctx.selectedProduct,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedProduct) = $event)),
                                items: _ctx.filteredProductTags,
                                "item-value": "id",
                                "return-object": "",
                                class: "mt-0",
                                dense: "",
                                "hide-details": "",
                                "item-title": (item) => item.name
                              }, null, 8, ["modelValue", "items", "item-title"])
                            ]),
                            _createElementVNode("td", _hoisted_8, [
                              _createVNode(_component_v_btn_icon, {
                                color: "secondary",
                                size: "x-small",
                                variant: "flat",
                                elevation: "0",
                                disabled: !_ctx.selectedProduct.id,
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.pushNewAllocation())),
                                icon: "$add"
                              }, null, 8, ["disabled"])
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["headers", "items"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["modelValue", "valid-disabled", "valid-title", "validLoading"])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}